import Moment from 'moment'
import { showToast } from 'common/modules/toaster'


export default function generateGetServices(actionKeyPrefix, options) {
  const actions = {}
  const reducers = {}

  const startType = `${actionKeyPrefix}_POST_START`.toUpperCase()
  actions.postStart = args => ({
    type: startType,
    requestTime: Moment().unix(),
    payload: args,
  })

  reducers[startType] = state => ({
    ...state,
    isModifying: true,
    isError: false,
  })


  const successType = `${actionKeyPrefix}_POST_SUCCESS`.toUpperCase()
  actions.postSuccess = response => ({
    type: successType,
    requestTime: Moment().unix(),
    payload: response,
  })

  reducers[successType] = (state, action) => ({
    ...state,
    isModifying: false,
    data: [...state.data, action.payload],
    lastUpdated: action.requestTime,
  })


  const errorType = `${actionKeyPrefix}_POST_ERROR`.toUpperCase()
  actions.postError = errorMessage => ({
    type: errorType,
    requestTime: Moment().unix(),
    payload: errorMessage,
  })

  reducers[errorType] = state => ({
    ...state,
    isModifying: false,
    isError: true,
  })


  actions.post = (...args) =>
    (dispatch, getState) => {
      dispatch(actions.postStart(...args))
      return options.services.post.service(getState, ...args)
        .then(response => {
          dispatch(actions.postSuccess(response))

          if (options.services.post.showOnSuccess) {
            dispatch(showToast({
              title: options.t('post.title'),
              message: (options.services.post.successMessage
                ? options.services.post.successMessage(response, ...args)
                : options.t('post.success')),
              level: 'success',
            }))
          }
        })
        .catch(error => {
          dispatch(actions.postError(error.description))

          if (options.services.post.showOnError) {
            dispatch(showToast({
              title: options.t('post.title'),
              message: (options.services.post.errorMessage
                ? options.services.post.errorMessage(error, ...args)
                : error.description),
              level: 'error',
            }))
          }
        })
    }

  return { actions, reducers }
}
